export default class AvalancheStore {
  constructor() {
    this.avalancheSize = null;
    this.avalancheType = null;
    this.triggerType = null;
    this.triggerRemote = null;
    this.materialDamageExists = null;
    this.personDamageExists = null;
    this.avalancheMoisture = null;
    this.victims = [];
  }
  setAvalancheSize(avalancheSize) {
    this.avalancheSize = avalancheSize;
  }
  getAvalancheSize() {
    return this.avalancheSize;
  }
  setAvalancheType(avalancheType) {
    this.avalancheType = avalancheType;
  }
  getAvalancheType() {
    return this.avalancheType;
  }
  setTriggerType(triggerType) {
    this.triggerType = triggerType;
  }
  getTriggerType() {
    return this.triggerType;
  }
  setAvalancheMoisture(avalancheMoisture) {
    this.avalancheMoisture = avalancheMoisture;
  }
  getAvalancheMoisture() {
    return this.avalancheMoisture;
  }
  setTriggerRemote(triggerRemote) {
    this.triggerRemote = triggerRemote;
  }
  getTriggerRemote() {
    return this.triggerRemote;
  }
  setMaterialDamageExists(materialDamageExists) {
    this.materialDamageExists = materialDamageExists;
  }
  getMaterialDamageExists() {
    return this.materialDamageExists;
  }
  setPersonDamageExists(personDamageExists) {
    this.personDamageExists = personDamageExists;
  }
  getPersonDamageExists() {
    return this.personDamageExists;
  }
  getVictims() {
    return this.victims;
  }
  addVictim(victim) {
    this.victims.push(victim);
  }
  removeVictim(index) {
    this.victims.splice(index, 1);
  }
  clearVictims() {
    this.victims = [];
  }
}
